import { render } from "./footer.vue?vue&type=template&id=6066335a"
const script = {}

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__